import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import AddRestaurant from "./pages/AddRestaurant";
import DeliveryPartner from "./pages/DeliveryPartner";
import AddRestaurantForm from "./pages/AddRestaurantForm";
import AllRestaurants from "./pages/AllRestaurants";
import SingleRestaurant from "./pages/SingleRestaurant";
import Profile from "./pages/Profile";
import Orders from "./pages/Orders";
import Feedback from "./pages/Feedback";
import Wallet from "./pages/Wallet";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import About from "./pages/About";
import WhyUs from "./pages/WhyUs";
import Contact from "./pages/Contact";
import PaymentProfile from "./pages/PaymentProfile";

const AllRoutes = () => {
  return (
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route exact path="/about-us" element={<About />} />
      <Route exact path="/why-us" element={<WhyUs />} />
      <Route exact path="/add-restaurant" element={<AddRestaurant />} />
      <Route
        exact
        path="/add-restaurant/form"
        element={<AddRestaurantForm />}
      />
      <Route exact path="/delivery-partner" element={<DeliveryPartner />} />
      <Route exact path="/all-restaurants" element={<AllRestaurants />} />
      <Route
        exact
        path="/all-restaurants/detail"
        element={<SingleRestaurant />}
      />
      <Route exact path="/setup-payment-profile" element={<PaymentProfile />} />
      <Route exact path="/account/profile" element={<Profile />} />
      <Route exact path="/account/orders" element={<Orders />} />
      <Route exact path="/account/feedback" element={<Feedback />} />
      <Route exact path="/contact" element={<Contact />} />
      <Route exact path="/account/wallet" element={<Wallet />} />
      <Route exact path="/privacy-policy" element={<Privacy />} />
      <Route exact path="/terms" element={<Terms />} />
    </Routes>
  );
};

export default AllRoutes;
